import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import Indicator from './Indicator';
import { sliderClass } from './styles';
import { per2value, value2per } from './utils';
import { isRTL } from '../config';
import { isFunc } from '../utils/is';
var DefaultValue = {
  formatValue: function formatValue(v) {
    return v;
  }
};

var Slider =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Slider, _PureComponent);

  var _super = _createSuper2(Slider);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _super.call(this, props);
    _this.parentElement = void 0;
    _this.state = {
      dragging: false,
      length: value2per(props.value, props.scale)
    };
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    _this.handleDrag = _this.handleDrag.bind(_assertThisInitialized(_this));
    _this.handleDragEnd = _this.handleDragEnd.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Slider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          value = _this$props.value,
          scale = _this$props.scale;
      var dragging = this.state.dragging;
      var len = scale.length;

      if (prevProps.value !== value || !dragging && prevProps.scale[len - 1] !== scale[len - 1]) {
        // eslint-disable-next-line
        this.setState({
          length: value2per(value, scale)
        });
      }
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      if (el && el.parentElement) this.parentElement = el.parentElement;
    }
  }, {
    key: "length2value",
    value: function length2value(length) {
      var _this$props2 = this.props,
          scale = _this$props2.scale,
          step = _this$props2.step;
      return per2value(length, scale, step);
    }
  }, {
    key: "handleDrag",
    value: function handleDrag(mx, my) {
      var _this$props3 = this.props,
          scale = _this$props3.scale,
          onDrag = _this$props3.onDrag,
          value = _this$props3.value,
          vertical = _this$props3.vertical,
          onIncrease = _this$props3.onIncrease;
      var m = vertical ? my / this.parentElement.clientHeight : mx / this.parentElement.clientWidth * (isRTL() ? -1 : 1);
      var length = this.state.length;
      var min = this.props.min ? value2per(this.props.min, scale) : 0;
      var max = this.props.max ? value2per(this.props.max, scale) : 1;
      var newLength = length + (vertical ? -m : m);
      var needIncrease = newLength > 1;
      if (newLength < min) newLength = min;
      if (newLength > max) newLength = max;
      if (needIncrease && onIncrease) onIncrease();
      this.setState({
        length: newLength,
        dragging: true
      });

      if (onDrag) {
        var newValue = this.length2value(newLength);
        if (newValue !== value) onDrag(newValue);
      }
    }
  }, {
    key: "handleDragEnd",
    value: function handleDragEnd() {
      var length = this.state.length;
      var scale = this.props.scale;
      var value = this.length2value(length);
      this.setState({
        length: value2per(value, scale),
        dragging: false
      });
      this.props.onChange(this.props.index, value);
    }
  }, {
    key: "renderResult",
    value: function renderResult() {
      var _this$props4 = this.props,
          autoHide = _this$props4.autoHide,
          _this$props4$formatVa = _this$props4.formatValue,
          formatValue = _this$props4$formatVa === void 0 ? DefaultValue.formatValue : _this$props4$formatVa;
      if (!formatValue || !isFunc(formatValue)) return null;
      var dragging = this.state.dragging;
      var className = sliderClass('result', (!autoHide || dragging) && 'show');
      var value = formatValue(this.length2value(this.state.length));
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className
        }, value)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          index = _this$props5.index,
          disabled = _this$props5.disabled,
          vertical = _this$props5.vertical;
      var length = this.state.length;
      if (index === 1) length = 1 - length;

      var style = _defineProperty({}, vertical ? 'height' : 'width', "".concat(length * 100, "%"));

      var className = sliderClass('bar', vertical && (index === 1 ? 'top' : 'bottom'), !vertical && index === 1 && 'right');
      return (
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindElement,
          style: style,
          className: className
        }, this.renderResult(),
        /*#__PURE__*/
        React.createElement("div", {
          className: sliderClass('bar-bg')
        }),
        /*#__PURE__*/
        React.createElement(Indicator, {
          disabled: disabled,
          onDrag: this.handleDrag,
          onDragEnd: this.handleDragEnd
        }))
      );
    }
  }]);

  return Slider;
}(PureComponent);

Slider.defaultProps = DefaultValue;
export default Slider;